import { render } from "./examHistoryList.vue?vue&type=template&id=704cf0ed&scoped=true&ts=true"
import script from "./examHistoryList.vue?vue&type=script&lang=ts"
export * from "./examHistoryList.vue?vue&type=script&lang=ts"

import "./examHistoryList.vue?vue&type=style&index=0&id=704cf0ed&scoped=true&lang=scss"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-704cf0ed"]])

export default __exports__